module.exports = __webpack_public_path__ + "json/buildings-9.json?5e111cb13d2fecba07ff50fa322641bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-9.json
// module id = 1728
// module chunks = 3